<template>
  <div class="user_management_form">
    <div class="page-title mb-2" v-if="$route.name === 'EditProfile'">แก้ไขโปรไฟล์</div>
    <div class="page-title mb-2" v-else>{{ $route.name !== 'EditProfile' && $route.params.id ? 'แก้ไขผู้ใช้งาน' : 'เพิ่มผู้ใช้งาน' }}</div>


    <div class="user_form py-8">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="px-6">
          <v-col cols="4" class="py-0">
            <label> คำนำหน้า<span style="color: #f15a29">*</span> </label>
            <v-autocomplete
              v-model="form.title"
              :items="title_masters"
              item-text="name"
              item-value="name"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุคำนำหน้า']"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" class="py-0">
            <label> ชื่อ<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.firstname"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุชื่อ']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="py-0">
            <label> สกุล<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.lastname"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุสกุล']"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="px-6">
          <v-col cols="4" class="py-0">
            <label> โทรศัพท์</label>
            <v-text-field
              v-model="form.phone"
              outlined
              dense
              class="mt-2"
              oninput="value=value.replace(/[^\d]/g,'')"
              min="0"
              color="#F7941D"
              placeholder="02XXXXXXX"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="py-0">
            <label> โทรศัพท์มือถือ<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.mobile_phone"
              outlined
              dense
              class="mt-2"
              oninput="value=value.replace(/[^\d]/g,'')"
              min="0"
              color="#F7941D"
              placeholder="09XXXXXXXX"
              :rules="[
                (v) => !!v || 'กรุณาระบุเบอร์โทรศัพท์มือถือ',
              ]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="py-0">
            <label> Email<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.email"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[
                (v) => !!v || 'กรุณาระบุอีเมล',
                (v) => /.+@.+\..+/.test(v) || 'รูปแบบอีเมลไม่ถูกต้อง',
              ]"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="px-6">
          <v-col cols="6" class="py-0" v-if="$route.name !== 'EditProfile'" >
            <label> กำหนดสิทธิ์<span style="color: #f15a29">*</span> </label>
            <v-autocomplete
              v-model="form.user_type"
              :items="user_type_master"
              item-text="name"
              item-value="name"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุกำหนดสิทธิ์']"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" class="py-0" v-else >
            <label>สิทธิ์<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.user_type"
              disabled
              outlined
              dense
              class="mt-2"
              placeholder="โปรดระบุ"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="form.user_type !== 'ผู้ประกอบการ'" cols="6" class="py-0">
            <label> ตำแหน่ง<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.position"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุตำแหน่ง']"
              required
            ></v-text-field>
          </v-col>
          <v-col v-else cols="6" class="py-0">
            <label> ชื่อบริษัท<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.company"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุชื่อบริษัท']"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="form.user_type === 'ผู้ประกอบการ'" cols="6" class="py-0">
            <label> ตำแหน่ง<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.position"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุตำแหน่ง']"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="form.user_type === 'ผู้ประกอบการ'"  cols="6" class="py-0">
            <label> ภูมิภาค<span style="color: #f15a29">*</span> </label>
            <v-autocomplete
              v-model="form.region"
              :items="regions"
              item-text="name"
              item-value="name"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุจังหวัด']"
              required
            ></v-autocomplete>
          </v-col>
          <v-col v-if="form.user_type === 'ผู้ประกอบการ'"  cols="6" class="py-0">
            <label> จังหวัด<span style="color: #f15a29">*</span> </label>
            <v-autocomplete
              v-model="form.province"
              :items="provinces"
              item-text="name"
              item-value="name"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุจังหวัด']"
              required
            ></v-autocomplete>
          </v-col>
          <v-col v-if="userRole === 'RSP' && form.user_type === 'ผู้เชี่ยวชาญ'" cols="6" class="py-0">
            <label> ภาค<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.region"
              outlined
              dense
              disabled
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุภาค']"
              required
            ></v-text-field>
          </v-col>
          <v-col :cols="userRole === 'RSP' && form.user_type === 'ผู้เชี่ยวชาญ' ? '6' : '12'" class="py-0" v-if="form.user_type == 'ผู้เชี่ยวชาญ'">
            <label>
              แผนงานการพิจารณา<span style="color: #f15a29">*</span>
            </label>
            <v-autocomplete
              v-model="form.plan_id"
              :items="filteredPlanMasters"
              item-text="plan_name_th"
              item-value="id"
              outlined
              multiple
              dense
              :disabled="userRole === 'RSP'"
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุแผนงานการพิจารณา']"
              required
            >
              <template v-slot:selection="data">
                <v-chip outlined color="orange">
                  {{ data.item.plan_name_th }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row
          class="px-6"
          v-if=" (form.user_type == 'USP' || form.user_type == 'RSP') && $route.name !== 'EditProfile' " 
        >
          <v-col cols="6" class="py-0" >
            <label> ภูมิภาค<span style="color: #f15a29">*</span> </label>
            <v-autocomplete
              v-model="form.region"
              :items="regions"
              item-text="name"
              item-value="name"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุภูมิภาค']"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" class="py-0">
            <label> จังหวัด<span style="color: #f15a29">*</span> </label>
            <v-autocomplete
              v-model="form.province"
              :items="provinces"
              item-text="name"
              item-value="name"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุจังหวัด']"
              required
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row class="px-6 pt-4">
          <v-col  cols="6" class="py-0">
            <label class="mr-4">
              หน่วยงาน<span style="color: #f15a29">*</span>
            </label>
            <v-autocomplete
              v-model="form.university_id"
              :items="
                form.user_type == 'USP' ? university_masters : institute_masters
              "
              :item-text="form.user_type == 'USP' ? 'name_th' : 'name'"
              item-value="id"
              outlined
              dense
              :disabled="form.user_type === 'ผู้ประกอบการ'"
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[form.user_type !== 'ผู้ประกอบการ' ? (v) => !!v || 'กรุณาระบุหน่วยงาน' : () => true]"
              required
            ></v-autocomplete>

          </v-col>
          <v-col cols="6" class="py-0" v-if="$route.name !== 'EditProfile'">
            <label class="font-w-500">
              ระยะเวลาการใช้งาน
              <span style="color: #f15a29">*</span>
              <span class="font-12 font-w-500" style="color: #b1b1b1">
                (ปี/เดือน/วัน)
              </span>
            </label>
            <v-menu
              v-model="menu_expiration_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="expiration_date"
                  placeholder="โปรดระบุ"
                  append-icon="mdi-calendar"
                  readonly
                  height="36"
                  outlined
                  style="border-radius: 30px"
                  :disabled="form.user_type === 'ผู้ประกอบการ'"
                  class="mt-2"
                  :rules="[form.user_type !== 'ผู้ประกอบการ' ? (v) => !!v || 'กรุณาระบุวันที่สิ้นสุด' : () => true]"
                  required
                  v-bind="attrs"
                  v-on="on"
                  background-color="#fff"
                  color="#F7941D"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.expiration_date"
                color="#F7941D"
                @input="menu_expiration_date = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="6" class="py-0" v-else>
            <label class="font-w-500">
              ระยะเวลาการใช้งาน
              <span style="color: #f15a29">*</span>
              <span class="font-12 font-w-500" style="color: #b1b1b1">
                (ปี/เดือน/วัน)
              </span>
            </label>
            <v-menu
              v-model="menu_expiration_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
              disabled
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="expiration_date"
                  placeholder="โปรดระบุ"
                  append-icon="mdi-calendar"
                  disabled
                  height="36"
                  outlined
                  style="border-radius: 30px"
                  class="mt-2"
                  :rules="[(v) => !!v || 'กรุณาระบุวันที่สิ้นสุด']"
                  required
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>

            </v-menu>
          </v-col>
        </v-row>

       

        <v-divider class="my-4"></v-divider>
         <v-col v-if="form.user_type === 'ผู้ประกอบการ'"  cols="6" class=" py-1 pl-5">
            <label> รหัสผ่าน<span style="color: #f15a29">*</span> </label>
            <v-text-field
              v-model="form.password"
              :type="showPasswordForEntrepreneur ? 'text' : 'password'"
              outlined
              dense
              class="mt-2"
              color="#F7941D"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุรหัสผ่าน']"
              required
              :append-icon="showPasswordForEntrepreneur ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="togglePasswordVisibility"
            ></v-text-field>
          </v-col> 
        <v-row class="px-6" v-if="$route.name !== 'EditProfile'">
          <v-col cols="6" class="py-0 d-flex align-center">
            <label class="pr-4">
              สถานะ<span style="color: #f15a29">*</span>
            </label>
            <v-switch
              color="#59CB33"
              dense
              inset
              class="switch-theme"
              v-model="form.status"
              false-value="0"
              true-value="1"
              :label="
                form.status == 1 ? 'อนุมัติผู้ใช้งาน' : 'ไม่อนุมัติผู้ใช้งาน'
              "
            ></v-switch>
          </v-col>
        </v-row>

        <v-row class="px-6 pt-4" v-else>
            <v-col cols="6" class="py-0 mb-4">
              <label class="pr-4">
                แก้ไขรหัสผ่านใหม่
              </label>
              <v-text-field
                v-model="form.password"
                outlined
                dense
                class="mt-2"
                color="#F7941D"
                :placeholder="$route.params.id ? 'ถ้าจะเปลี่ยนรหัสผ่านให้ระบุ' : 'โปรดระบุ'"
                :type="show_password ? 'text' : 'password'"
                :rules="[
                  (v) => !v || v.length >= 6 || 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
                ]"
                @input="$forceUpdate()"
              >
                <template v-slot:append>
                  <v-icon
                    :color="show_password ? '#F7941D' : '#b1b1b1'"
                    @click="show_password = !show_password"
                  >
                    {{ show_password ? 'mdi-eye' : 'mdi-eye-off' }}
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" class="py-0 mb-4" v-if="form.password && form.password.length >= 6">
              <label class="pr-4">
                ยืนยันรหัสผ่าน
              </label>
              <v-text-field
                v-model="form.confirmPassword"
                outlined
                dense
                class="mt-2"
                color="#F7941D"
                :placeholder="$route.params.id ? 'ถ้าจะเปลี่ยนรหัสผ่านให้ระบุ' : 'โปรดระบุ'"
                :type="show_cfpassword ? 'text' : 'password'"
                :rules="[
                  (v) => !v || v.length >= 6 || 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
                  (v) => !v || v === form.password || 'กรุณากรอกรหัสผ่านให้ตรงกัน',
                ]"
                @input="$forceUpdate()"
              >
                <template v-slot:append>
                  <v-icon
                    :color="show_cfpassword ? '#F7941D' : '#b1b1b1'"
                    @click="show_cfpassword = !show_cfpassword"
                  >
                    {{ show_cfpassword ? 'mdi-eye' : 'mdi-eye-off' }}
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>


      </v-form>
    </div>

    <v-layout justify-end align-center mt-6>
      <v-flex shrink mr-4>
        <v-btn
          width="100"
          height="35"
          depressed
          rounded
          color="#D9D9D9"
          @click="$router.push({ name: 'UserManagement' })"
        >
          <span class="font-14 font-w-700 font-ch">ยกเลิก</span>
        </v-btn>
      </v-flex>
      <v-flex shrink>
        <v-btn
          width="100"
          height="35"
          dark
          rounded
          class="btn_gradient"
          @click="onSubmit"
        >
          <span class="font-14 font-w-700 font-ch">บันทึก</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "UserFormManagement",
  components: {
    Icon,
  },
  data() {
    return {
      valid: true,
      menu_expiration_date: false,
      show_password: false,
      show_cfpassword: false,
      form: {
        title: "",
        firstname: "",
        lastname: "",
        phone: "",
        mobile_phone: "",
        email: "",
        position: "",
        university_id: "",
        user_type: "",
        plan_id: [],
        region: "",
        province: "",
        expiration_date: "",
        status: 0,
        // password: "",
      },
      user_type_master: [],
      institute_list: [],
      institute_masters: [],
      position_masters: [],
      title_masters: [],
      university_masters: [],
      regions: [],
      provinces: [],
      plan_masters: [],
      showInputPassword: false,
      showPasswordForEntrepreneur:false,
    };
  },
  computed: {
    expiration_date: {
      get() {
        return this.form.expiration_date
          ? moment(this.form.expiration_date).format("YYYY/MM/DD")
          : "";
      },
      set(val) {
        this.form.expiration_date = val;
      },
    },
    filteredPlanMasters() {
      if (this.userRole === "RSP" && this.form.user_type === "ผู้เชี่ยวชาญ") {
        return this.plan_masters.filter(
          (plan) => plan.plan_name_th === "แผนงานบริหารจัดการอาคาร"
        );
      }
      if (this.userRole === "สป.อว.") {
        return this.plan_masters.filter(
          (plan) =>
            plan.plan_name_th !== "แผนงานบริหารจัดการอาคาร" &&
            plan.plan_name_th !== "แผนงาน RSP Management"
        );
      }
      return this.plan_masters;
    },
    ...mapState({
      userRole: (state) => state.Auth.User?.user_type,
      user : state => state.Auth.User
    }),
  },
  created() {
    if(this.$route.name == "EditProfile"){
      this.userEdit(this.user.id);
    }else{
      if (this.$route.params.id) {
      this.userEdit(this.$route.params.id);
      } else {
        this.userCreate();
        this.showInputPassword = true;
      }
    }
    

    /*
      check role เพื่อกำหนดรายการสิทธิ์การใช้งาน 
      - ถ้าเป็น user ที่ loging เข้ามาเป็น RSP จะเลือกได้แค่ RSP
      - ถ้าเป็น user ที่ loging เข้ามาเป็น สป.อว. จะเลือกได้ rsp, สป.อว. และ ผู้เชี่ยวชาญ
    */
    if (this.userRole == "RSP") {
      this.user_type_master = ["USP","ผู้ประกอบการ", "ผู้เชี่ยวชาญ"];
    } else if (this.userRole == "สป.อว.") {
      this.user_type_master = ["RSP", "USP", "สป.อว.", "ผู้เชี่ยวชาญ"];
    }
  },
  watch: {
    'form.user_type'(newVal) {
      if (newVal === 'ผู้เชี่ยวชาญ' && this.userRole === 'RSP') {
        const plan = this.plan_masters.find(p => p.plan_name_th === 'แผนงานบริหารจัดการอาคาร');
        this.form.plan_id = plan ? [plan.id] : [];
        this.form.region = this.user?.region || '';
      }
    },
  },
  methods: {
    async userCreate() {
      let res = await this.$apiFire("Auth/create");
      if (res) {
        // console.log(res);
        this.institute_masters = res.institute_masters;
        this.position_masters = res.position_masters;
        this.title_masters = res.title_masters;
        this.university_masters = res.university_masters;
        this.regions = res.regions;
        this.provinces = res.provinces;
        this.plan_masters = res.plan_masters;
      }
    },
    async userEdit(id) {
      let res = await this.$apiFire("Auth/edit", {
        id: id,
      });
      if (res) {
        // console.log(res);
        this.form = res.user;
        // this.form.password = "";
        this.form.status =
          res.user?.status === null ? 0 : res.user?.status.toString();
        this.institute_masters = res.institute_masters;
        this.position_masters = res.position_masters;
        this.title_masters = res.title_masters;
        this.university_masters = res.university_masters;
        this.regions = res.regions;
        this.provinces = res.provinces;
        this.plan_masters = res.plan_masters;
      }
    },

    async onSubmit() {
      if (this.$refs.form.validate()) {
        // update user profile & edit UserManagement
        if (this.$route.params.id || this.$route.name == "EditProfile") {
          let res = await this.$apiFire("Auth/update", {
            id: this.$route.name == "EditProfile" ? this.user.id : this.$route.params.id,
            data: this.form,
          },true);
          console.log(res)
         
          if (res && res.message === "แก้ไขผู้ใช้งานสำเร็จ") {
            if( this.$route.name == "EditProfile"){
              this.$store.commit("Auth/setUserInfo", res.data);
              this.$store.commit("General/setModal", {
                  title: "เสร็จสิ้น!",
                  theme: "success",
                  text: "บันทึกข้อมูลสำเร็จ",
                  showCancel: false,
                  action: () => this.$router.push({ name: "UserManagement" }),
                });
            }else{
              this.$store.commit("General/setModal", {
                title: "เสร็จสิ้น!",
                theme: "success",
                text: "บันทึกข้อมูลสำเร็จ",
                showCancel: false,
                action: () => this.$router.push({ name: "UserManagement" }),
              });
            }    
          }
        }

        // create user
        else {
          let res = await this.$apiFire("Auth/store", this.form, true);
          console.log("res:")
          console.log(res)
          if (res && res.message === "สร้างผู้ใช้งานสำเร็จ") {
            this.$store.commit("General/setModal", {
              title: "เสร็จสิ้น!",
              theme: "success",
              text: "บันทึกข้อมูลสำเร็จ",
              showCancel: false,
              action: () => this.$router.push({ name: "UserManagement" }),
            });
          }
        }
      }
    },

    onChangeUserType() {
      if (this.form.user_type == "USP") {
        this.form.university_id = "";
      }
    },
    togglePasswordVisibility() {
      this.showPasswordForEntrepreneur = !this.showPasswordForEntrepreneur;
    },
  },
};
</script>

<style lang="scss">
.user_management_form {
  .btn_gradient {
    background: linear-gradient(90deg, #f15a29 0%, #fbb040 100%) !important;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25) !important;
    color: #fff !important;
  }
  .user_form {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;

    label {
      font-weight: 500;
      font-size: 14px;
      color: #000000;
    }
    .v-input__slot,
    .v-text-field.v-text-field--solo .v-input__control {
      min-height: 40px !important;
      border-radius: 30px;
    }

    .v-text-field--full-width .v-input__prepend-outer,
    .v-text-field--full-width .v-input__prepend-inner,
    .v-text-field--full-width .v-input__append-inner,
    .v-text-field--full-width .v-input__append-outer,
    .v-text-field--enclosed .v-input__prepend-outer,
    .v-text-field--enclosed .v-input__prepend-inner,
    .v-text-field--enclosed .v-input__append-inner,
    .v-text-field--enclosed .v-input__append-outer {
      margin-top: 8px !important;
    }
    .v-input--is-readonly:not(.picker-field) .v-input__slot {
      background-color: #ffffff !important;
    }
    i.v-icon.notranslate.mdi.mdi-calendar.theme--light {
      color: #f7941d !important;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
  
}
.user_management_form .user_form i.v-icon.notranslate.mdi.mdi-calendar.theme--light{
  color: #dddd !important; 

}
</style>
